module.exports = __webpack_public_path__ + "img/head-side-cough.0a09608b.svg";